export default "__VITE_ASSET__BsT$U4V5__"